 /**
 * Menu.js
 * Nested Menu Component
 *
 * @class   Menu
 * @author  Randy Lebeau
 *
 */

import React from 'react';
import CssEvent from 'utils/css-event';
import Dom from 'utils/dom';
import KeyLine from 'utils/key-line';
import ClassNames from 'classnames';
import Paper from 'components/paper/Paper';
import NestedMenu from 'components/menu/NestedMenu';
import MenuItem from 'components/menu/MenuItem';
import LinkMenuItem from 'components/menu/LinkMenuItem';
import SubheaderMenuItem from 'components/menu/SubheaderMenuItem';


/****************
* Menu Component
****************/
export default React.createClass({

	propTypes: {
		autoWidth: React.PropTypes.bool,
		onItemTap: React.PropTypes.func,
		onItemClick: React.PropTypes.func,
		onToggleClick: React.PropTypes.func,
		menuItems: React.PropTypes.array.isRequired,
		selectedIndex: React.PropTypes.number,
		hideable: React.PropTypes.bool,
		visible: React.PropTypes.bool,
		zDepth: React.PropTypes.number,
		status: React.PropTypes.string,
		header: React.PropTypes.any
	},

	getInitialState() {
		return { nestedMenuShown: false }
	},

	getDefaultProps() {
		return {
			autoWidth: true,
			hideable: false,
			visible: true,
			zDepth: 1,
			status: 'primary'
		};
	},

	componentDidMount() {
		let el = React.findDOMNode(this);

		//Set the menu with
		this._setKeyWidth(el);

		//Save the initial menu height for later
		this._initialMenuHeight = el.offsetHeight + KeyLine.Desktop.GUTTER_LESS;

		//Show or Hide the menu according to visibility
		this._renderVisibility();
	},

	componentDidUpdate(prevProps, prevState) {
		if (this.props.visible !== prevProps.visible) this._renderVisibility();
	},

	render() {
		let classes = ClassNames('lui-menu', `lui-is-${this.props.status}`, {
			'lui-menu-hideable': this.props.hideable,
			'lui-visible': this.props.visible,
		});

		return (
			<Paper ref="paperContainer" zDepth={this.props.zDepth} className={classes}>
				{this._getHeader()}
				{this._getChildren()}
			</Paper>
		);
	},

	_getHeader(){
		if (this.props.header){
			return (
				<div className='lui-menu-header'>
					{this.props.header}
				</div>
			)
		}
	},

	_getChildren() {
		let children = [],
			menuItem,
			itemComponent,
			isSelected,
			isDisabled;

		//This array is used to keep track of all nested menu refs
		this._nestedChildren = [];

		for (let i=0; i < this.props.menuItems.length; i++) {
			menuItem = this.props.menuItems[i];
			isSelected = i === this.props.selectedIndex;
			isDisabled = (menuItem.disabled === undefined) ? false : menuItem.disabled;

			let {
				icon,
				data,
				attribute,
				number,
				toggle,
				onClick,
			} = menuItem;

			let onItemClick;

			if (onClick) {
				onItemClick = onClick;
			} else {
				onItemClick = this._onItemClick;
			}

			switch (menuItem.type) {

				case MenuItem.Types.LINK:
					itemComponent = (
						<LinkMenuItem
							key={`${menuItem.text}-${i}`}
							index={i}
							payload={menuItem.payload}
							target={menuItem.target}
							text={menuItem.text}
							disabled={isDisabled} />
					);
					break;

				case MenuItem.Types.SUBHEADER:
					itemComponent = (
						<SubheaderMenuItem
							key={`${menuItem.text}-${i}`}
							index={i}
							text={menuItem.text} />
					);
					break;

				case MenuItem.Types.NESTED:
					itemComponent = (
						<NestedMenuItem
							ref={i}
							key={`${menuItem.text}-${i}`}
							index={i}
							text={menuItem.text}
							disabled={isDisabled}
							menuItems={menuItem.items}
							zDepth={this.props.zDepth}
							onItemClick={this._onNestedItemClick}
							onItemTap={this._onNestedItemClick} />
					);
					this._nestedChildren.push(i);
					break;

				default:
					itemComponent = (
						<MenuItem
							{...this.props}
							selected={isSelected}
							key={`${menuItem.text}-${i}`}
							index={i}
							href={menuItem.href}
							target={menuItem.target}
							icon={menuItem.icon}
							data={menuItem.data}
							attribute={menuItem.attribute}
							number={menuItem.number}
							toggle={menuItem.toggle}
							disabled={isDisabled}
							onClick={onItemClick}
							onTouchTap={this._onItemTap}>
							{menuItem.text}
						</MenuItem>
					);
			}
			children.push(itemComponent);
		}

		return children;
	},

	_setKeyWidth(el) {
		let menuWidth = this.props.autoWidth ?
			KeyLine.getIncrementalDim(el.offsetWidth) + 'px' :
			'100%';

		//Update the menu width
		Dom.withoutTransition(el, function() {
			el.style.width = menuWidth;
		});
	},

	_renderVisibility() {
		let el;

		if (this.props.hideable) {
			el = React.findDOMNode(this);
			let innerContainer = this.refs.paperContainer.getInnerContainer();
			innerContainer = React.findDOMNode(innerContainer);

			if (this.props.visible) {

				//Open the menu
				el.style.height = this._initialMenuHeight + 'px';

				//Set the overflow to visible after the animation is done so
				//that other nested menus can be shown
				CssEvent.onTransitionEnd(el, ()=> {
					//Make sure the menu is open before setting the overflow.
					//This is to accout for fast clicks
					if (this.props.visible) innerContainer.style.overflow = 'visible';
				});

			} else {

				//Close the menu
				el.style.height = '0px';

				//Set the overflow to hidden so that animation works properly
				innerContainer.style.overflow = 'hidden';
			}
		}
	},

	_onNestedItemClick(e, index, menuItem) {
		if (this.props.onItemClick) this.props.onItemClick(e, index, menuItem);
	},

	_onNestedItemTap(e, index, menuItem) {
		if (this.props.onItemTap) this.props.onItemTap(e, index, menuItem);
	},

	_onItemClick(e, index) {
		if (this.props.onItemClick) this.props.onItemClick(e, index, this.props.menuItems[index]);
	},

	_onItemTap(e, index) {
		if (this.props.onItemTap) this.props.onItemTap(e, index, this.props.menuItems[index]);
	},

	_onItemToggle(e, index, toggled) {
		if (this.props.onItemToggle) this.props.onItemToggle(e, index, this.props.menuItems[index], toggled);
	}

});



/** WEBPACK FOOTER **
 ** ./src/components/menu/Menu.js
 **/